import { useStore } from '@/state/store';
import { project } from '@/engine';
import { comparisonToCsv, monthlyRowsToCsv } from '@/csv/exportCsv';
import { dateStamp, downloadText } from '@/lib/download';
import { printReport } from '@/lib/print';

const btn = 'rounded-md border border-slate-300 px-2 py-1 text-sm hover:bg-slate-100 dark:border-slate-600 dark:hover:bg-slate-800';

/** Print-to-PDF and CSV export (§10.10). */
export function ExportButtons() {
  const result = useStore((s) => s.result);
  const name = useStore((s) => s.currentName);
  const selection = useStore((s) => s.ui.comparisonSelection);
  const scenarios = useStore((s) => s.scenarios);
  const isComparison = selection.length >= 2;

  const exportCsv = () => {
    if (isComparison) {
      const items = selection
        .map((id) => scenarios.find((s) => s.id === id))
        .filter((s): s is NonNullable<typeof s> => !!s)
        .map((s) => {
          const r = project(s.inputs);
          return { name: s.name, summary: r.summary, estateDifference: r.estate.difference };
        });
      downloadText(`PAL-comparison-${dateStamp()}.csv`, comparisonToCsv(items), 'text/csv');
    } else if (result) {
      downloadText(`PAL-${name}-${dateStamp()}.csv`, monthlyRowsToCsv(result), 'text/csv');
    }
  };

  return (
    <div className="flex items-center gap-2">
      <button type="button" className={btn} onClick={() => printReport(name, isComparison ? 'comparison' : 'report')}>
        Print / PDF
      </button>
      <button type="button" className={btn} onClick={exportCsv} disabled={!result}>
        CSV
      </button>
    </div>
  );
}
